import React, { useMemo } from 'react';
import { useAuth } from '../../auth/AuthProvider';
import OrderDetailPanel from '../components/OrderDetailPanel';
import OrderList from '../components/OrderList';
import { useOnTimeLiveData } from '../hooks/useOnTimeLiveData';

export default function OnTimeMyViewPage() {
  const { user, claims } = useAuth();
  const { orders, drivers, usingMock } = useOnTimeLiveData();
  const email = String(user?.email || '').toLowerCase();
  const role = String(claims?.role || '').toLowerCase();

  const mine = useMemo(() => {
    if (role.includes('driver')) {
      return orders.filter((order) => String(order.assignedDriver || '').toLowerCase() === email || String(order.assignedDriver || '').toLowerCase() === String(user?.displayName || '').toLowerCase());
    }
    if (role.includes('store')) {
      return orders.filter((order) => String(order.store || '').toLowerCase().includes(String(claims?.storeId || '').toLowerCase()));
    }
    return orders.filter((order) => String(order.assignedOnline || '').toLowerCase() === email || String(order.assignedOnline || '').toLowerCase() === String(user?.displayName || '').toLowerCase());
  }, [orders, role, email, user?.displayName, claims?.storeId]);

  const selected = mine[0] || null;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold text-white">My View</h2>
        <p className="mt-1 text-sm text-slate-400">Your assigned slice of Link.</p>
      </div>
      {usingMock ? (
        <div className="rounded-2xl border border-amber-400/20 bg-amber-500/10 px-4 py-3 text-sm text-amber-200">
          Showing mock operational data until your org has live Link documents.
        </div>
      ) : null}
      <div className="grid gap-6 xl:grid-cols-[minmax(0,1fr)_420px]">
        <section className="rounded-3xl border border-white/10 bg-white/5 p-4">
          <OrderList orders={mine} selectedId={selected?.id} onSelect={() => {}} onAction={() => {}} />
        </section>
        <OrderDetailPanel order={selected} drivers={drivers} />
      </div>
    </div>
  );
}
